__turbopack_context__.v({
  "PageCard": "_5kr-7q_PageCard",
  "PageCard__Bottom": "_5kr-7q_PageCard__Bottom",
  "PageCard__Content": "_5kr-7q_PageCard__Content",
  "PageCard__Date": "_5kr-7q_PageCard__Date",
  "PageCard__ImageWrap": "_5kr-7q_PageCard__ImageWrap",
  "PageCard__Link": "_5kr-7q_PageCard__Link",
  "PageCard__LinkText": "_5kr-7q_PageCard__LinkText",
  "PageCard__Preamble": "_5kr-7q_PageCard__Preamble",
  "PageCard__Title": "_5kr-7q_PageCard__Title",
});
